// 搜索头部option
export const searchFormOption = function() {
  return [
    {
      prop: 'keyword',
      label: '工号',
      type: 'input',
      placeholder: '请输入内容'
    },
    {
      prop: 'dateList',
      label: '时记录日期',
      type: 'range-picker',
    },
  ]
}
// 修改编辑option
export const editFormOption = function() {
  return [
    {
      prop: 'val1',
      label: '输入',
      type: 'input',
      placeholder: '请输入内容'
    },
    {
      prop: 'val2',
      label: '下拉',
      type: 'select',
      placeholder: '请选择内容',
      options: []
    },
    {
      prop: 'val4',
      label: '时间区间',
      type: 'range-picker',
    },
    {
      prop: 'val6',
      label: '日期区间',
      type: 'range-date',
    },
    {
      prop: 'val5',
      label: '级联',
      type: 'cascader',
      placeholder: '请选择内容',
      propConfig: {
        value: 'id',
        label: 'name'
      },
      options: []
    },
    {
      prop: 'upload',
      label: '文件上传',
      type: 'upload',
    },
    {
      prop: 'editor',
      label: '富文本',
      type: 'editor',
    },
  ]
}

export default {}